import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["SecurityHeadersFaq"] */ "/app/src/components/tools/SecurityHeadersFaq.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SecurityHeadersTool"] */ "/app/src/components/tools/SecurityHeadersTool.tsx");
